<template>
  <div class="p-0 flex flex-col items-center justify-start min-h-[75vh]">
    <div class="container max-w-screen-lg mx-auto">
      <div>

        <!-- modal -->
        <ModalQuestions
          :open="questionModalOpen"
          :canClose="true"
          @submit="registerQuestion"
          @close="close"
        />

        <div class="bg-white rounded shadow-lg p-4 px-4 md:p-8 mb-6">
          <div class="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
            <div class="text-left block mb-4">
              <p class="mb-2 font-medium text-lg text-gray-900">
                {{ descriptionTitle }}
              </p>
              <p class="text-gray-500">
                Campos com <span class="text-red-500">*</span> são obrigatórios
              </p>

              <div class="flex justify-center" :key="store.state.events.banner">
                <img
                  v-if="selectedFileUrl || store.state.events.banner"
                  :src="selectedFileUrl ?? fileUrl + store.state.events.banner"
                  alt="Banner do evento"
                  class="mt-10 mb-auto rounded-md w-60 max-h-60 hidden md:block"
                />
              </div>
            </div>

            <div id="form-fields" class="lg:col-span-2 space-y-6 text-start">
              <div
                class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
              >
                <!-- dados do curso -->
                <div
                  @click="toggleEventsTab"
                  class="cursor-pointer md:col-span-5 uppercase"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      detalhes do treinamento
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': eventsTab }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="eventsTab"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      <!-- titulo -->
                      <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="title"
                          v-model="store.state.events.title"
                          label="Titulo"
                          :info="'Informe o nome do treinamento'"
                          :required-field="true"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.state.events.title = null"
                            />
                          </template>
                        </BaseInput>

                        <span
                          name="events.title"
                          class="text-red-600 text-sm"
                        />
                      </div>

                      <!-- tag -->
                      <div class="md:col-span-2">
                        <BaseInput
                          type="text"
                          name="tag"
                          v-model="store.state.events.tag"
                          label="NR / TAGS / ID"
                          :info="'NR / TAGS / ID'"
                          :required-field="false"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton
                              @click="store.state.events.tag = null"
                            />
                          </template>
                        </BaseInput>
                      </div>

                      <!-- date -->
                      <!-- <div class="md:col-span-2">
                        <BaseInput
                          type="date"
                          name="date"
                          v-model="store.state.events.date"
                          label="Data do evento"
                          :info="'Informe a data do evento'"
                          :required-field="false"
                          :activeDefault="true"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.events.date = null" />
                          </template>
                        </BaseInput>
                      </div> -->

                      <!-- description -->
                      <div class="md:col-span-5">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="form.employee"
                          >
                            Descrição <a class="text-red-600 ml-1">*</a>
                          </label>
                          <div class="mx-1 mt-2">
                            <textarea
                              name="description"
                              v-model="store.state.events.description"
                              class="input-field"
                            >
                            </textarea>
                          </div>
                        </div>
                      </div>

                      <!-- location -->
                      <!-- <div class="md:col-span-3">
                        <BaseInput
                          type="text"
                          name="location"
                          v-model="store.state.events.location"
                          label="Local"
                          :info="'Local do evento'"
                          :required-field="false"
                          :activeDefault="false"
                        >
                          <template #append>
                            <CleanInputButton @click="store.state.events.location = null" />
                          </template>
                        </BaseInput>
                      </div> -->
                    </div>
                  </Transition>
                </div>

                <!-- videoaula -->
                <div
                  @click="togglePrivacityTab"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      VIDEOAULA
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': linksPrivacityTab }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="linksPrivacityTab"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      <!-- modulo -->
                      <div class="md:col-span-2">
                        <div>
                          <BaseInput
                            type="text"
                            name="title"
                            v-model="store.state.events.classDraft.module_id"
                            label="Módulo"
                            :info="'Informe o modulo desta aula'"
                            placeholder="Introdução a plataforma"
                            :required-field="true"
                            :activeDefault="false"
                          >
                            <template #append>
                              <CleanInputButton @click="store.state.events.classDraft.module_id = null" />
                            </template>
                          </BaseInput>
                        </div>
                      </div>

                      <!-- titulo -->
                      <div class="md:col-span-3">
                        <div>
                          <BaseInput
                            type="text"
                            name="title"
                            v-model="store.state.events.classDraft.title"
                            label="Titulo da aula"
                            :info="'Titulo da aula'"
                            :required-field="true"
                            :activeDefault="false"
                          >
                            <template #append>
                              <CleanInputButton @click="store.state.events.classDraft.title = null" />
                            </template>
                          </BaseInput>
                        </div>
                      </div>

                      <!-- youtube_video_id -->
                      <div class="md:col-span-5">
                        <div>
                          <BaseInput
                            type="text"
                            name="form.realizado_em"
                            v-model.trim="youtubeUrl"
                            label="Link"
                            :info="'Link da video aula'"
                            :required-field="true"
                            :activeDefault="true"
                          >
                            <template #append>
                              <CleanInputButton @click="youtubeUrl = null" />
                            </template>
                          </BaseInput>
                        </div>
                      </div>

                      <!-- player / botões-->
                      <div class="md:col-span-5">
                        <Transition mode="out-in">
                          <div
                            v-show="youtubeUrl != '' && youtubeUrl != null"
                            class="md:col-span-5 border p-3"
                          >
                            <!-- Player -->
                            <div
                              class="aspect-video w-full rounded overflow-hidden bg-black"
                            >
                              <div
                                id="yt-picker"
                                ref="pickerEl"
                                class="w-full h-full"
                              ></div>
                            </div>

                            <!-- Controles do tempo -->
                            <div class="mt-3 flex items-center gap-2">
                              <button
                                type="button"
                                class="px-3 py-2 rounded bg-zinc-800 text-white"
                                @click="nudge(-5)"
                              >
                                -5s
                              </button>
                              <button
                                type="button"
                                class="px-3 py-2 rounded bg-zinc-800 text-white"
                                @click="markNow"
                              >
                                Marcar tempo atual
                              </button>
                              <button
                                type="button"
                                class="px-3 py-2 rounded bg-zinc-800 text-white"
                                @click="nudge(5)"
                              >
                                +5s
                              </button>

                              <span class="ml-4 text-sm text-zinc-600">
                                Tempo atual:
                                <strong>{{ currentTimeFormatted }}</strong>
                              </span>
                            </div>
                          </div>
                        </Transition>
                      </div>

                      <!-- bloco de perguntas -->
                      <div class="md:col-span-5">
                        <Transition mode="out-in">
                          <div
                            class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                          >
                            <!-- have questions? -->
                            <div class="md:col-span-2">
                              <div class="md:col-span-2 mt-1.5">
                                <label
                                  class="text-left flex pl-1 text-xs text-[#2b3038]"
                                  for="relatosForm.empresa"
                                >
                                  Possui questões?
                                </label>
                                <div class="h-10 flex rounded items-center text-center">
                                  <!-- :key="clearOnSelected" -->
                                  <SimpleSelect
                                    class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                                    :data="yesOrNo"
                                    :disable-keyboard="true"
                                    @selected-data="handleHasQuestionSelection"
                                  />
                                </div>
                              </div>
                            </div>

                            <!-- module -->
                            <!-- <div class="md:col-span-3">
                              <Transition mode="out-in">
                                <div
                                  v-show="store.state.has_question?.value == true"
                                  class="md:col-span-2 mt-1.5"
                                >
                                  <label
                                    class="text-left flex pl-1 text-xs text-[#2b3038]"
                                    for="relatosForm.empresa"
                                  >
                                    Modulo
                                  </label>
                                  <div class="h-10 flex rounded items-center">
                                    <SimpleSelect
                                      class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                                      :key="clearOnSelected"
                                      :data="modules"
                                      :disable-keyboard="true"
                                      @selected-data="
                                        (val) =>
                                          (store.state.events.classDraft.module_id = val)
                                      "
                                    />
                                  </div>
                                </div>
                              </Transition>
                            </div> -->

                            <!-- questões -->
                            <div class="md:col-span-5">
                              <Transition mode="out-in">
                                <div
                                  v-show="store.state.has_question?.value == true"
                                  class="md:col-span-5"
                                >
                                  <div
                                    class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                                  >
                                    <!-- question -->
                                    <div class="md:col-span-3 col-span-3">
                                      <div class="md:col-span-2 mt-1.5">
                                        <label
                                          class="text-left flex pl-1 text-xs text-[#2b3038]"
                                          for="relatosForm.empresa"
                                        >
                                          Questões
                                        </label>
                                        <div class="h-10 flex rounded items-center">
                                          <SimpleSelect
                                            class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                                            :key="clearOnSelected"
                                            :data="question"
                                            :disable-keyboard="false"
                                            @selected-data="
                                              (val) => {
                                                if(val) {
                                                  addQuestion(val.value, val.name)
                                                }
                                              }
                                            "
                                          />
                                        </div>
                                      </div>
                                    </div>

                                    <!-- time -->
                                    <div class="md:col-span-1 col-span-1 text-gray-500">
                                      <BaseInput
                                        name="percent"
                                        v-model.number="currentTimeFormatted"
                                        :required-field="false"
                                        :info="'Minuto no video'"
                                        label="Minuto no video"
                                        :center="true"
                                        :disabled="true"
                                      >
                                      </BaseInput>

                                      <span
                                        name="percent"
                                        class="text-red-600 text-sm"
                                      />
                                    </div>

                                    <!-- botão de adição -->
                                    <!-- <div class="col-span-1">
                                      <div class="h-full">
                                        <button
                                          @click="addQuestion"
                                          title="Adicionar questão"
                                          class="px-2 py-2 bg-gradient-to-r to-[#93cd24] from-[#0c7036] mt-3 text-white rounded-full hover:cursor-pointer transition-all hover:scale-105 text-center flex justify-center mx-auto"
                                        >
                                          <component
                                            class="w-8 h-8"
                                            :is="PhListPlus"
                                          ></component>
                                        </button>
                                      </div>
                                    </div> -->

                                    <!-- Botão de Adicionar -->
                                    <div class="col-span-1">
                                      <div class="h-full">
                                        <button
                                          title="Cadastrar questão"
                                          class="px-2 py-2 bg-gradient-to-r to-[#93cd24] from-[#0c7036] mt-3 text-white rounded-full hover:cursor-pointer transition-all hover:scale-105 text-center flex justify-center"
                                          @click="questionModalOpen = !questionModalOpen"
                                        >
                                          <component class="w-8 h-8" :is="PhListPlus"></component>
                                        </button>
                                      </div>
                                    </div>

                                  </div>

                                  <!-- combo -->
                                  <div
                                    class="mt-3 w-full max-h-[20vh] overflow-auto"
                                  >
                                    <h3
                                      class="text-lg font-semibold text-start sticky top-0 bg-white p-1"
                                    >
                                      Perguntas adicionadas:
                                      {{ questionsCount }}
                                    </h3>

                                    <ul
                                      v-if="draftQuestions?.length"
                                      class="flex flex-wrap"
                                    >
                                      <li
                                        v-for="(q, i) in draftQuestions"
                                        :key="q.id"
                                        class="flex justify-between bg-gray-100 p-2 rounded-md m-1 gap-3"
                                      >
                                        <div class="text-sm">
                                          <!-- questão-->
                                          <div class="font-semibold uppercase">
                                            {{
                                              q.label?.length > 15
                                              ? q.label.slice(0, 15).concat('...')
                                              : q.label
                                              ||
                                              "Pergunta #" + (q.question_id ?? "—")
                                            }}
                                          </div>

                                          <div class="text-gray-500">
                                            <!--
                                              Módulo: {{ q.module_id ?? "—" }} •
                                            -->
                                            • Tempo: <b>{{ q.time_label }}</b>

                                            <!-- pontos -->
                                            <span v-if="q.points">
                                              • Pontos: {{ q.points }}
                                            </span>

                                            <!-- required -->
                                            <span v-if="q.required">
                                              • Obrigatória
                                            </span>
                                          </div>
                                        </div>

                                        <!-- botão de remover -->
                                        <button
                                          @click="removeQuestion(i)"
                                          class="text-red-600 hover:text-red-800"
                                        >
                                          <component
                                            :is="PhXCircle"
                                            class="w-6 h-6"
                                          />
                                        </button>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </Transition>
                            </div>

                            <!-- nota minima -->
                            <div class="md:col-span-2">
                              <Transition mode="out-in">
                                <div
                                  v-show="store.state.has_question?.value == true"
                                  class="md:col-span-5"
                                >
                                  <div class="md:col-span-2 mt-1.5">
                                    <label
                                      class="text-left flex pl-1 text-xs text-[#2b3038]"
                                      for="relatosForm.empresa"
                                    >
                                      Possui nota mínima?
                                    </label>
                                    <div class="h-10 flex rounded items-center">
                                      <!-- :key="clearOnSelected" -->
                                      <SimpleSelect
                                        class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                                        :data="yesOrNo"
                                        :disable-keyboard="true"
                                        @selected-data="handleHasMinimumGradeSelection"
                                      />
                                    </div>
                                  </div>
                                </div>
                              </Transition>
                            </div>

                            <!-- nota -->
                             <div class="md:col-span-2">
                              <Transition mode="out-in">
                                <div
                                  v-show="store.state.has_minimum_grade?.value == true"
                                  class="md:col-span-2 col-span-2"
                                >
                                  <BaseInput
                                    name="percent"
                                    v-model="store.state.events.classDraft.min_grade_required"
                                    :required-field="false"
                                    :info="'Nota mínima para aprovação'"
                                    label="Nota mínima para aprovação"
                                    type="number"
                                    :min="0"
                                    :max="10"
                                  >
                                    <template #append>
                                      <CleanInputButton
                                        @click="
                                          store.state.events.classDraft.min_grade_required = undefined
                                        "
                                      />
                                    </template>
                                  </BaseInput>

                                  <span
                                    name="percent"
                                    class="text-red-600 text-sm"
                                  />
                                </div>
                              </Transition>
                            </div>
                          </div>
                        </Transition>

                        <div
                          v-if="isEditingClass"
                          class="mt-3 rounded-md border border-amber-200 bg-amber-50 p-3 text-sm text-amber-900"
                        >
                          Você está alterando uma aula existente. Salve a aula para aplicar as mudanças ou cancele a edição.
                        </div>

                        <!-- total de aulas -->
                        <div class="mt-3 w-full max-h-[28vh] overflow-auto">
                          <h3
                            class="text-lg font-semibold text-start sticky top-0 bg-white p-1"
                          >
                            Aulas adicionadas:
                            {{ classesCount }}
                          </h3>

                          <ul v-if="classes?.length" class="flex flex-wrap">
                            <li
                              v-for="(c, i) in classes"
                              :key="c.id ?? `${i}-${c.video_id}`"
                              draggable="true"
                              @dragstart="onClassDragStart(i)"
                              @dragover.prevent
                              @drop="onClassDrop(i)"
                              class="bg-gray-100 p-3 rounded-md m-1 w-full md:w-[30%] border-2 transition-all cursor-move"
                              :class="isEditingClass && editingClassIndex === i ? 'border-amber-400 bg-amber-50' : 'border-transparent'"
                            >
                              <div class="flex justify-between items-start gap-3">
                                <div class="min-w-0">
                                  <div class="font-semibold">
                                    <code>{{
                                      (c.title ?? 'sem titulo').length > 14
                                      ? (c.title ?? 'sem titulo').slice(0, 14).concat('...')
                                      : c.title ?? 'sem titulo'
                                    }}</code>
                                  </div>
                                  <div class="text-gray-500">
                                    Módulo: {{ resolveModuleLabel(c) }}
                                  </div>

                                  <div class="text-gray-500">
                                    Perguntas: {{ c.questions?.length ?? 0 }}
                                  </div>

                                  <div class="text-gray-500" v-if="c.min_grade_required != null && c.min_grade_required !== ''">
                                    Nota mínima: {{ c.min_grade_required }}
                                  </div>

                                  <div class="font-semibold break-all">
                                    Vídeo: <code>{{ c.video_id }}</code>
                                  </div>
                                </div>

                                <div class="flex items-center gap-2 shrink-0">
                                  <button
                                    type="button"
                                    @click="startEditClass(i, c)"
                                    class="text-amber-600 hover:text-amber-800"
                                    title="Editar aula"
                                  >
                                    <component
                                      :is="PhNotePencil"
                                      class="w-6 h-6"
                                    />
                                  </button>

                                  <button
                                    type="button"
                                    @click="removeClassCard(i, c)"
                                    class="text-red-600 hover:text-red-800"
                                    title="Remover aula"
                                  >
                                    <component
                                      :is="PhXCircle"
                                      class="w-6 h-6"
                                    />
                                  </button>
                                </div>
                              </div>
                            </li>
                          </ul>
                        </div>
                      </div>

                      <!-- adicionar aula -->
                      <section class="md:col-span-5 flex justify-end gap-3 -mt-5">
                        <button
                          v-if="isEditingClass"
                          type="button"
                          class="px-4 py-2 rounded-md border border-zinc-300 text-zinc-700 hover:bg-zinc-50"
                          @click="cancelClassEdition"
                        >
                          Cancelar edição
                        </button>

                        <CreateButton
                          @click="addClass"
                          :icon="isEditingClass ? PhNotePencil : PhCirclesThreePlus"
                          :width-maximus="true"
                          :label="isEditingClass ? 'salvar aula' : 'adicionar aula'"
                        />
                      </section>
                    </div>
                  </Transition>
                </div>

                <!-- turmas -->
                <!-- <div
                  @click="toggleParticipantsTab"
                  class="cursor-pointer md:col-span-5"
                >
                  <div
                    class="flex justify-between items-center bg-gray-100 rounded p-1"
                  >
                    <label class="font-medium text-lg text-gray-800 p-1 -ml-1">
                      PARTICIPANTES
                    </label>
                    <component
                      :is="PhCaretUp"
                      class="w-6 h-6 transition-all"
                      :class="{ 'rotate-180': this.participantsTab }"
                    ></component>
                  </div>
                </div>

                <div class="md:col-span-5">
                  <Transition mode="out-in">
                    <div
                      v-show="this.participantsTab"
                      class="grid gap-4 gap-y-2 text-sm grid-cols-1 md:grid-cols-5"
                    >
                      empresas
                      <div class="md:col-span-2">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.empresa"
                          >
                            Empresa
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :key="clearOnSelected"
                              :data="fighters"
                              :disable-keyboard="true"
                              @selected-data="
                                (val) => (store.state.selectedFighter = val)
                              "
                            />
                          </div>
                        </div>
                      </div>

                      fighters
                      <div class="md:col-span-2">
                        <div class="md:col-span-2 mt-1.5">
                          <label
                            class="text-left flex pl-1 text-xs text-[#2b3038]"
                            for="relatosForm.empresa"
                          >
                            Alunos
                          </label>
                          <div class="h-10 flex rounded items-center">
                            <SimpleSelect
                              class="px-1 py-2 text-center uppercase appearance-none outline-none text-gray-800 w-full bg-transparent"
                              :key="clearOnSelected"
                              :data="fighters"
                              :disable-keyboard="true"
                              @selected-data="
                                (val) => (store.state.selectedFighter = val)
                              "
                            />
                          </div>
                        </div>
                      </div>

                      botão
                      <div class="col-span-1">
                        <div class="h-full">
                          <button
                            @click="addIntegrante"
                            title="Adicionar integrante"
                            class="px-2 py-2 bg-gradient-to-r to-[#93cd24] from-[#0c7036] mt-3 text-white rounded-full hover:cursor-pointer transition-all hover:scale-105 text-center flex justify-center"
                          >
                            <component
                              class="w-8 h-8"
                              :is="PhUserPlus"
                            ></component>
                          </button>
                        </div>
                      </div>

                      Lista de Integrantes
                      <div class="md:col-span-5">
                        <div class="mt-3 w-full max-h-[20vh] overflow-auto">
                          <h3
                            class="text-lg font-semibold text-start sticky top-0 bg-white p-1"
                          >
                            Integrantes adicionados:
                            {{ store.state.events.integrantes?.length }}
                          </h3>
                          <ul
                            class="flex flex-wrap"
                            v-if="store.state.events.integrantes?.length"
                          >
                            <li
                              v-for="(integrante, index) in store.state.events
                                .integrantes"
                              :key="index"
                              class="flex justify-between bg-gray-100 p-2 rounded-md m-1"
                            >
                              <label>
                                <label class="font-bold uppercase">
                                  <small
                                    class="text-gray-400 font-normal lowercase"
                                  >
                                    lutador:
                                  </small>
                                  {{
                                    integrante.nome?.length > 20
                                      ? integrante.nome
                                          .slice(0, 20)
                                          .concat("...")
                                      : integrante.nome
                                  }}
                                  <br />
                                </label>

                                <label
                                  class="font-bold text-green-500"
                                  v-if="integrante?.descAmount"
                                >
                                  <small class="text-gray-400 font-normal">
                                    desconto de:
                                  </small>
                                  {{ integrante?.descAmount }} <br />
                                </label>

                                <label
                                  class="font-bold text-green-500"
                                  v-if="integrante?.descPorcent"
                                >
                                  <small class="text-gray-400 font-normal">
                                    desconto de:
                                  </small>
                                  {{ integrante?.descPorcent }}% <br />
                                </label>
                              </label>
                              <button
                                @click="removeIntegrante(index, integrante.id)"
                                class="text-red-500 hover:text-red-700 flex px-1"
                              >
                                <component
                                  :is="PhX"
                                  class="w-5 h-5 rounded-full bg-white p-0.5"
                                ></component>
                              </button>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </Transition>
                </div> -->

                <!-- fluxo da imagem -->
                <div class="flex justify-center">
                  <img
                    v-if="selectedFileUrl || store.state.events.banner"
                    :src="
                      selectedFileUrl ?? fileUrl + store.state.events.banner
                    "
                    alt="Banner do evento"
                    class="mt-2 rounded-md w-60 max-h-60 block md:hidden"
                  />
                </div>

                <div class="md:col-span-5 md:-mt-1 flex h-10">
                  <label
                    class="cursor-pointer bg-gray-100 hover:bg-gray-300 transition-all min-w-[8rem] h-10 rounded-l-md rounded-r-none"
                  >
                    <div class="flex mt-auto mb-auto h-full">
                      <div class="w-full mt-auto mb-auto flex justify-center">
                        <component
                          :is="selectedFileName ? image : fileImage"
                          class="w-5 h-5 mr-1"
                          :class="[
                            selectedFileName
                              ? 'text-green-500'
                              : 'text-gray-500',
                          ]"
                        />

                        Banner
                      </div>
                    </div>
                    <input
                      type="file"
                      class="hidden"
                      @change="handleFileChange"
                    />
                  </label>
                  <input
                    type="text"
                    style="padding-left: 10px !important"
                    class="border rounded w-full h-10 rounded-r-md rounded-l-none"
                    :value="selectedFileName"
                  />
                </div>

              </div>
            </div>
          </div>

          <!-- Botão de Salvar -->
          <div class="text-right flex justify-center mt-8">
            <slot />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SimpleSelect from '@/components/Select/SimpleSelect.vue'
import CleanInputButton from '../utils/CleanInputButton.vue'
import BaseInput from '@/components/Inputs/BaseInput.vue'
import BlogEditor from '@/components/BlogEditor.vue'
import { sectorPriority, yesOrNo, modules, question } from '../lookups/form'
import { dataEvent } from '../store'
import { PhCaretUp, PhNotePencil, PhUserPlus, PhX, PhCirclesThreePlus, PhFileImage, PhImage, PhListPlus, PhXCircle } from '@phosphor-icons/vue'
import { showToast as toast } from '@/helpers/UseToasts'
import CreateButton from '@/components/Buttons/Create.vue'
import { computed, ref } from 'vue'
import EventService from '../service/event.service'
import { mapActions } from 'vuex'
import ModalQuestions from '@/modules/extinguisher/components/_partials/ModalQuestions.vue'

import ExtinguisherService from '@/modules/extinguisher/service/extinguisher.service'
import { dataExtinguisher } from '@/modules/extinguisher/store'
import { storeApp } from '@/store'

export default {
  name: 'RegisterForm',
  components: {
    SimpleSelect,
    CleanInputButton,
    BaseInput,
    BlogEditor,
    CreateButton,
    ModalQuestions,
  },
  props: {
    descriptionTitle: String,
    create: {
      type: Boolean,
      default: true
    }
  },
  data () {
    const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
    const store = dataEvent
    const storeExtinguisher = dataExtinguisher

    const fighters = computed(() => dataEvent.getters.getAllFighters)
    const question = computed(() => dataEvent.getters.getQuestionCollect)

    return {
      PhCaretUp,
      PhUserPlus,
      PhX,
      PhListPlus,
      PhCirclesThreePlus,
      PhXCircle,

      PhNotePencil,

      yesOrNo,
      modules,
      question,

      fileImage: PhFileImage,
      image: PhImage,
      selectedFileName: undefined,
      selectedFileUrl: undefined,
      dataEvent,
      sectorPriority,
      fileUrl,
      toast,
      store,
      fighters,

      rawPrice: null,

      eventsTab: false,
      valuesTab: true,
      participantsTab: false,
      linksPrivacityTab: false,

      clearOnSelected: 0,

      // youtube e ações
      youtubeUrl: '', // v-model do campo do link
      player: null, // instância YT.Player
      apiReady: false,
      currentTime: 0, // tempo atual do vídeo (s)
      tickId: null, // interval para atualizar o relógio

      // Campos do formulário para “marcar questão”
      questionTimeSeconds: 0, // valor preciso
      questionTimeMinutes: 0, // valor arredondado p/ seu input “Minuto no vídeo”

      selectedModuleId: null,
      selectedQuestionId: null,
      selectedQuestionLabel: '',
      questionPoints: null,
      questionRequired: false,
      questionModalOpen: false,
      editingClassIndex: null,
      draggingClassIndex: null,
      storeApp,
      storeExtinguisher
    }
  },
  computed: {
    draft () {
      return this.store.getters.classDraft
    },
    classes () {
      return this.store.getters.classes
    },
    questionsCount () {
      return this.store.getters.questionsCount
    },
    classesCount () {
      return this.store.getters.classesCount
    },
    draftQuestions () {
      return this.store.getters.draftQuestions
    },
    currentTimeFormatted () {
      return this.formatTime(this.currentTime)
    },
    isEditingClass () {
      return this.editingClassIndex !== null
    }
  },
  watch: {
    // quando o link mudar, (re)carrega o player
    youtubeUrl (newVal) {
      const id = this.extractVideoId(newVal)
      this.store.dispatch('setDraftField', { key: 'video_url', value: newVal || null })
      this.store.dispatch('setDraftField', { key: 'video_id', value: id })

      if (!id) {
        this.destroyPlayer()
        return
      }
      this.ensureYTApi(() => this.loadVideo(id))
    },
    selectedModuleId (val) {
      this.store.dispatch('setDraftField', {
        key: 'module_id',
        value: val || null
      })
    },

    // sincroniza minutos <-> segundos (bidirecional)
    questionTimeMinutes (val) {
      if (Number.isFinite(val)) { this.questionTimeSeconds = Math.max(0, Math.round(val * 60)) }
    },
    questionTimeSeconds (val) {
      if (Number.isFinite(val)) this.questionTimeMinutes = Math.floor(val / 60)
    }
  },
  methods: {
    ...mapActions([
      'setDraftField',
      'resetDraft',
      'addDraftQuestion',
      'updateDraftQuestion',
      'removeDraftQuestion',
      'addClassFromDraft',
      'removeClass'
    ]),
    formatDescAmount (event) {
      const onlyDigits = event.target.value.replace(/\D/g, '')
      const formatted = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
      }).format(onlyDigits / 100)

      this.store.state.events.descAmount = formatted
    },
    toggleEventsTab () {
      this.valuesTab = false
      this.linksPrivacityTab = false

      this.eventsTab = !this.eventsTab
    },
    toggleValuesTab () {
      this.linksPrivacityTab = false
      this.eventsTab = false

      this.valuesTab = !this.valuesTab
    },
    togglePrivacityTab () {
      this.valuesTab = false
      this.eventsTab = false

      this.linksPrivacityTab = !this.linksPrivacityTab
    },
    toggleParticipantsTab () {
      this.valuesTab = false
      this.eventsTab = false
      this.linksPrivacityTab = false

      this.participantsTab = !this.participantsTab
    },
    addIntegrante () {
      const id = this.store.state.selectedFighter?.value
      const nome = this.store.state.selectedFighter?.name?.trim()
      // const descAmount = this.store.state.events.descAmount?.trim();
      // const descPorcent = this.store.state.events.descPorcent?.trim();

      if (!nome) {
        alert('Informe um lutador antes de adicionar.')
        return
      }

      this.store.commit('ADD_INTEGRANTE', {
        id,
        nome
        // descAmount,
        // descPorcent,
      })

      // Limpa os campos
      this.store.state.selectedFighter = null
      // this.store.state.events.descAmount = "";
      // this.store.state.events.descPorcent = "";

      this.clearOnSelected++
    },
    removeIntegrante (index, cId) {
      this.store.state.events.integrantes.splice(index, 1)

      if (!this.create) {
        Promise.allSettled([
          EventService.removeFighter(cId, this.store.state.events?.id)
            .then((res) => {
              console.log(res.data)
            })
            .catch((err) => {
              if (
                err?.response?.data?.error &&
                err.response.data.status === 400
              ) {
                return toast('Aviso', err.response.data.message, 'error')
              }

              if (
                err?.response?.data?.error &&
                err.response.data.status === 404
              ) {
                return toast('Aviso', err.response.data.message, 'error')
              }

              return toast(
                'Aviso',
                'Algo deu errado com sua solicitação',
                'error'
              )
            })
        ])
      }
    },
    handleFileChange (event) {
      const file = event.target.files[0]
      if (file) {
        const allowedExtensions = ['webp', 'png', 'gif', 'jpeg', 'jpg']
        const fileExtension = file.name.split('.').pop().toLowerCase()
        if (allowedExtensions.includes(fileExtension)) {
          this.selectedFileName = file.name
          this.selectedFileUrl = URL.createObjectURL(file)
          this.store.state.events.banner = file
        } else {
          return this.toast(
            'Atenção',
            'Apenas imagens do tipo: webp, png, gif, jpeg e jpg são aceitas',
            'info'
          )
        }
      }
    },
    handleHasQuestionSelection (val) {
      this.store.dispatch('setHasQuestion', val)

      if (!val?.value) {
        this.questionTimeSeconds = 0
        this.questionTimeMinutes = 0
        this.questionPoints = null
        this.questionRequired = false
      }

      this.clearOnSelected++
    },
    handleHasMinimumGradeSelection (val) {
      this.store.dispatch('setHasMinimumGrade', val)
      this.clearOnSelected++
    },
    cloneValue (value) {
      console.log(value);
      return JSON.parse(JSON.stringify(value))
    },
    resolveModuleLabel (lesson) {
      if (!lesson) return '—'

      if (typeof lesson.module_id === 'string' && lesson.module_id.trim() !== '') {
        return lesson.module_id.trim()
      }

      if (typeof lesson.module_title === 'string' && lesson.module_title.trim() !== '') {
        return lesson.module_title.trim()
      }

      if (lesson.module_id && typeof lesson.module_id === 'object') {
        return lesson.module_id.name || lesson.module_id.label || lesson.module_id.value || '—'
      }

      return lesson.module_id ?? '—'
    },
    syncDraftUiFromClass (lesson) {
      const hasQuestions = Array.isArray(lesson?.questions) && lesson.questions.length > 0
      const hasMinimumGrade = lesson?.min_grade_required !== null && lesson?.min_grade_required !== undefined && lesson?.min_grade_required !== ''

      this.store.dispatch('setHasQuestion', hasQuestions ? this.yesOrNo.find(item => item.value === true) : false)
      this.store.dispatch('setHasMinimumGrade', hasMinimumGrade ? this.yesOrNo.find(item => item.value === true) : false)

      this.youtubeUrl = lesson?.video_url || (lesson?.video_id ? `https://www.youtube.com/watch?v=${lesson.video_id}` : '')
      this.questionTimeSeconds = 0
      this.questionTimeMinutes = 0
      this.questionPoints = null
      this.questionRequired = false
      this.clearOnSelected++
    },
    clearDraftEditor () {
      this.store.dispatch('resetDraft')
      this.store.dispatch('setHasQuestion', false)
      this.store.dispatch('setHasMinimumGrade', false)

      this.youtubeUrl = ''
      this.selectedModuleId = null
      this.selectedQuestionId = null
      this.selectedQuestionLabel = ''
      this.questionTimeSeconds = 0
      this.questionTimeMinutes = 0
      this.questionPoints = null
      this.questionRequired = false
      this.editingClassIndex = null
      this.draggingClassIndex = null
      this.clearOnSelected++
    },
    startEditClass (index, lesson) {
      const classToEdit = this.cloneValue(lesson)
      classToEdit.module_id = this.resolveModuleLabel(classToEdit)
      classToEdit.questions = Array.isArray(classToEdit.questions) ? classToEdit.questions : []

      this.store.state.events.classDraft = classToEdit
      this.editingClassIndex = index
      this.syncDraftUiFromClass(classToEdit)
    },
    cancelClassEdition () {
      this.clearDraftEditor()
    },
    // youtube
    extractVideoId (url) {
      if (!url) return null
      try {
        const u = new URL(url.trim())
        if (u.hostname.includes('youtu.be')) return u.pathname.slice(1)
        if (u.searchParams.get('v')) return u.searchParams.get('v')
        const path = u.pathname.split('/')
        const ix = path.findIndex((p) =>
          ['embed', 'shorts', 'live'].includes(p)
        )
        if (ix >= 0 && path[ix + 1]) return path[ix + 1]
        const m = url.match(/([a-zA-Z0-9_-]{11})/)
        return m ? m[1] : null
      } catch {
        const m = url.match(/([a-zA-Z0-9_-]{11})/)
        return m ? m[1] : null
      }
    },
    // --- carrega a IFrame API uma vez, e chama cb quando disponível
    ensureYTApi (cb) {
      if (window.YT && window.YT.Player) {
        this.apiReady = true
        return cb()
      }

      const self = this
      if (!window._ytApiWaiters) window._ytApiWaiters = []
      window._ytApiWaiters.push(() => {
        self.apiReady = true
        cb()
      })

      if (!document.getElementById('yt-iframe-api')) {
        const tag = document.createElement('script')
        tag.id = 'yt-iframe-api'
        tag.src = 'https://www.youtube.com/iframe_api'
        document.head.appendChild(tag)

        window.onYouTubeIframeAPIReady = function () {
          (window._ytApiWaiters || []).forEach((fn) => fn())
          window._ytApiWaiters = []
        }
      }
    },
    loadVideo (videoId) {
      const el = this.$refs.pickerEl
      if (!el) return

      if (this.player) {
        this.player.loadVideoById(videoId)
        return
      }

      this.player = new YT.Player(el, {
        videoId,
        playerVars: {
          controls: 1,
          autoplay: 1,
          rel: 0,
          modestbranding: 1,
          playsinline: 1,
          origin: window.location.origin,
          enablejsapi: 1
        },
        events: {
          onReady: this.onPlayerReady,
          onStateChange: this.onStateChange
        }
      })
    },
    destroyPlayer () {
      if (this.tickId) {
        clearInterval(this.tickId)
        this.tickId = null
      }
      if (this.player?.destroy) this.player.destroy()
      this.player = null
      this.currentTime = 0
    },
    onPlayerReady () {
      if (this.tickId) clearInterval(this.tickId)
      this.tickId = setInterval(() => {
        if (!this.player) return
        const t = this.player.getCurrentTime?.()
        if (typeof t === 'number') this.currentTime = t
      }, 200)
    },
    onStateChange () {},
    nudge (delta) {
      if (!this.player?.getCurrentTime) return
      const now = this.player.getCurrentTime() || 0
      const t = Math.max(0, now + delta)
      this.player.seekTo(t, true)
    },
    markNow () {
      const t = Math.max(0, Math.round(this.currentTime || 0))
      this.questionTimeSeconds = t
      this.questionTimeMinutes = Math.floor(t / 60)
    },
    formatTime (totalSeconds) {
      const s = Math.floor(totalSeconds || 0)
      const h = Math.floor(s / 3600)
      const m = Math.floor((s % 3600) / 60)
      const r = s % 60
      return h > 0
        ? `${String(h).padStart(2, '0')}:${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`
        : `${String(m).padStart(2, '0')}:${String(r).padStart(2, '0')}`
    },
    addQuestion (qId, qLb) {
      if (!this.draft.video_id) {
        this.toast('Aviso', 'Informe o link do vídeo', 'error')
        return
      }

      this.selectedQuestionId = qId
      this.selectedQuestionLabel = qLb

      const q = {
        id: Date.now(),
        title: this.store.state.events.classDraft.title ?? `Aula: ${Date.now()}`,
        module_id: this.resolveModuleLabel(this.store.state.events.classDraft),
        question_id: this.selectedQuestionId || null,
        label: this.selectedQuestionLabel || '',
        time_seconds: Math.max(0, Math.round(this.questionTimeSeconds || 0)),
        time_label: this.currentTimeFormatted,
        points: this.questionPoints ?? null,
        required: !!this.questionRequired
      }
      this.store.dispatch('addDraftQuestion', q)
      this.clearOnSelected++
    },
    prepareDraftPayload () {
      const draft = this.cloneValue(this.store.state.events.classDraft)
      console.log(this.store.state.events.classDraft);
      console.log(draft);
      draft.module_id = this.resolveModuleLabel(draft)
      draft.questions = Array.isArray(draft.questions) ? draft.questions : []

      const hasQuestions = !!this.store.state.has_question?.value
      const hasMinimumGrade = !!this.store.state.has_minimum_grade?.value

      if (!hasQuestions) {
        draft.questions = []
        draft.min_grade_required = null
      }

      if (hasQuestions && draft.questions.length === 0) {
        this.toast('Aviso', 'Adicione ao menos uma questão para a aula.', 'error')
        return null
      }

      if (!hasMinimumGrade) {
        draft.min_grade_required = null
      }

      if (hasQuestions && hasMinimumGrade && (draft.min_grade_required === null || draft.min_grade_required === '' || Number(draft.min_grade_required) < 0)) {
        this.toast('Aviso', 'Informe a nota mínima da aula.', 'error')
        return null
      }

      return draft
    },
    addClass () {
      if (!this.draft.video_id) {
        this.toast('Aviso', 'Informe o link do vídeo', 'error')
        return
      }

      const payload = this.prepareDraftPayload()
      if (!payload) return

      this.store.state.events.classDraft = payload

      if (this.isEditingClass) {
        this.store.dispatch('updateClassFromDraft', this.editingClassIndex)
      } else {
        this.store.dispatch('addClassFromDraft')
      }

      this.clearDraftEditor()
    },
    removeQuestion (index) {
      this.store.dispatch('removeDraftQuestion', index)

      if (!this.store.state.events.classDraft.questions.length) {
        this.store.dispatch('setHasQuestion', false)
        this.store.dispatch('setHasMinimumGrade', false)
      }
    },
    removeClassCard (index, lesson) {
      this.store.dispatch('removeClass', index)

      if (this.editingClassIndex === index) {
        this.cancelClassEdition()
      } else if (this.editingClassIndex !== null && this.editingClassIndex > index) {
        this.editingClassIndex -= 1
      }

      if (!this.create) {
        Promise.allSettled([
          EventService.removeClasses(lesson).catch((err) => {
            if (err?.response?.data?.error && err.response.data.status === 400) {
              return this.toast('Aviso', err.response.data.message, 'error')
            }

            if (err?.response?.data?.error && err.response.data.status === 404) {
              return this.toast('Aviso', err.response.data.message, 'error')
            }

            if (err?.response?.data?.error && err.response.data.status === 422) {
              return this.toast('Aviso', err.response.data.message, 'error')
            }

            return this.toast(
              'Aviso',
              'Algo deu errado ao remover aula',
              'error'
            )
          })
        ])
      }
    },
    onClassDragStart (index) {
      this.draggingClassIndex = index
    },
    onClassDrop (toIndex) {
      if (this.draggingClassIndex === null || this.draggingClassIndex === toIndex) {
        this.draggingClassIndex = null
        return
      }

      const fromIndex = this.draggingClassIndex
      this.store.dispatch('reorderClasses', { fromIndex, toIndex })

      if (this.editingClassIndex === fromIndex) {
        this.editingClassIndex = toIndex
      } else if (this.editingClassIndex !== null) {
        if (fromIndex < this.editingClassIndex && toIndex >= this.editingClassIndex) {
          this.editingClassIndex -= 1
        } else if (fromIndex > this.editingClassIndex && toIndex <= this.editingClassIndex) {
          this.editingClassIndex += 1
        }
      }

      this.draggingClassIndex = null
    },
    close () {
      this.questionModalOpen = false
    },
    registerQuestion () {
      this.storeApp.loading = true

      Promise.allSettled([
        ExtinguisherService.createQuestion(this.storeExtinguisher.state.question)
          .then(() => {
            this.toast(
              'Aviso',
              'Pergunta cadastrada com sucesso',
              'success'
            )

            dataEvent.commit('RESET_QUESTIONS_MODAL')
            dataEvent.dispatch('getComboQuestion')
            this.storeApp.loading = false
          }).catch(err => {
            this.storeApp.loading = false

            this.toast(
              'Aviso',
              'Pergunta cadastrada com sucesso',
              'success'
            )

            console.log(err)
          })
      ])
    }
  },
  mounted () {
    if (!this.draft?.id) this.store.dispatch('resetDraft')

    if (this.draft?.video_url || this.draft?.video_id) {
      this.syncDraftUiFromClass(this.draft)
    }
  },
  beforeUnmount () {
    this.destroyPlayer()
  }
}
</script>

<style lang="scss" scoped>
.input-field {
  display: block;
  width: 100%;
  padding: 10px;
  font-size: 16px;
  border-radius: 10px;
  border: 2px solid #ccc;
  outline: none;
  background-color: transparent;
  transition: border-color 0.3s ease-in-out;
}
</style>
